import { Link } from 'react-router-dom';
import { MonitorPlay } from 'lucide-react';
import { cn } from '../lib/cn';

export function Logo({ compact = false, className }: { compact?: boolean; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <span className="relative flex size-9 items-center justify-center overflow-hidden rounded-xl border border-white/10 bg-[#0b0d13] shadow-[0_0_24px_rgba(139,92,246,0.18)]">
        <span className="absolute inset-0 bg-[radial-gradient(circle_at_25%_15%,rgba(139,92,246,0.55),transparent_55%),radial-gradient(circle_at_80%_90%,rgba(34,211,238,0.35),transparent_55%)]" />
        <MonitorPlay className="relative size-[18px] text-white" strokeWidth={2} />
      </span>
      {!compact && (
        <span className="text-[17px] font-semibold tracking-[-0.03em] text-white">
          Stream<span className="text-zinc-400">Room</span>
        </span>
      )}
    </span>
  );
}

export function LogoLink({ className }: { className?: string }) {
  return (
    <Link to="/" aria-label="StreamRoom — на главную" className={className}>
      <Logo />
    </Link>
  );
}
